<script setup>
/**
 * @fileoverview Tabs component based on shadcn-vue
 * @description Tabbed interface with multiple panels
 * @example
 * <Tabs default-value="tab1">
 *   <TabsList>
 *     <TabsTrigger value="tab1">Tab 1</TabsTrigger>
 *     <TabsTrigger value="tab2">Tab 2</TabsTrigger>
 *   </TabsList>
 *   <TabsContent value="tab1">Content 1</TabsContent>
 *   <TabsContent value="tab2">Content 2</TabsContent>
 * </Tabs>
 */
import { TabsRoot } from 'radix-vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: undefined
  },
  defaultValue: {
    type: String,
    required: true
  },
  orientation: {
    type: String,
    default: 'horizontal'
  }
})

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <TabsRoot
    :model-value="modelValue"
    :default-value="defaultValue"
    :orientation="orientation"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <slot />
  </TabsRoot>
</template>
